import Dialog from '@mui/material/Dialog';
import { useTaskById } from 'features/tasks';
import React from 'react';
import { Habit } from 'shared/types/habit';
import { ID } from 'shared/types/id';
import { RepeatingTask } from 'shared/types/repeating-task';
import { Timestamp } from 'shared/types/timestamp';

import { ManualEntryLogForm } from './manual-entry-log-form';

export type HabitManualEntryLogDialogProps = {
  habitId?: ID;
  date?: Timestamp;
  onClose: () => void;
  onSubmit: (
    habit: Habit | RepeatingTask,
    date: Timestamp,
    value: number,
  ) => void;
};

export const HabitManualEntryLogDialog: React.FC<
  HabitManualEntryLogDialogProps
> = ({ habitId, date, onSubmit, onClose }) => {
  const task = useTaskById(habitId);

  const open = !!task?.schedules?.length && !!date;

  return (
    <Dialog open={open} fullWidth onClose={onClose}>
      {open && (
        <ManualEntryLogForm
          habit={task as Habit | RepeatingTask}
          date={date!}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Dialog>
  );
};
